import clsx from 'clsx'
import {FC, useCallback, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '@services/helper/common.helper'
import {INotification} from '@interface/notification.interface'
import {NotificationService} from '@services/api/notification.service'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks} from '_metronic/partials'
import {ChatLauncher} from './ChatLauncher'

const itemClass = 'ms-1 ms-lg-3',
  btnClass = 'btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px',
  userAvatarClass = 'symbol-30px symbol-md-40px'

/** How often the bell re-checks for new notifications (ms). */
const NOTIFICATION_POLL_MS = 60000

const Topbar: FC = () => {
  const [notifications, setNotifications] = useState<INotification[]>([])
  const [unreadCount, setUnreadCount] = useState(0)

  // The bell owns the feed + badge so both come from one poll. Failures are swallowed on
  // purpose — a notification outage must never break the header for the rest of the app.
  const loadNotifications = useCallback(() => {
    NotificationService.my()
      .then((res) => setNotifications(res?.body || []))
      .catch(() => {})
    NotificationService.unreadCount()
      .then((res) => setUnreadCount(res?.body || 0))
      .catch(() => {})
  }, [])

  useEffect(() => {
    loadNotifications()
    const timer = setInterval(loadNotifications, NOTIFICATION_POLL_MS)
    return () => clearInterval(timer)
  }, [loadNotifications])

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* Search */}
      {/* <div className={clsx('d-flex align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* CHAT: unread badge; hidden unless the company has Chat and this person can use it */}
      <ChatLauncher itemClass={itemClass} btnClass={btnClass} />

      {/* NOTIFICATIONS */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        {/*
          Do NOT add data-kt-menu-overflow='true' here — it re-parents the dropdown to <body>,
          outside #root, which silently kills every React onClick inside the menu.
        */}
        <div
          title='Notifications'
          className={clsx(btnClass, 'position-relative')}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <i className='bi bi-bell fs-2' />
          {unreadCount > 0 && (
            <span className='badge badge-circle badge-danger position-absolute top-0 start-100 translate-middle fs-9'>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </div>
        <HeaderNotificationsMenu
          items={notifications}
          unreadCount={unreadCount}
          onRefresh={loadNotifications}
        />
      </div>

      {/* Quick links */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        {/* begin::Menu wrapper */}
        <div
          title='Switch module'
          className={btnClass}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <i className='bi bi-grid-3x3-gap-fill fs-2' />
        </div>
        <QuickLinks />
        {/* end::Menu wrapper */}
      </div>

      {/* CHAT */}
      {/* <div className={clsx('d-flex align-items-center', itemClass)}>
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative',
            btnClass,
            'pulse pulse-success'
          )}
          id='kt_drawer_chat_toggle'
        >
          <i className='bi bi-app-indicator fs-2' />
          <span className='pulse-ring w-45px h-45px' />
        </div>
      </div> */}

      {/* begin::User */}
      <div className={clsx('d-flex align-items-center', itemClass)} id='kt_header_user_menu_toggle'>
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='user' />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

    </div>
  )
}

export {Topbar}
